/**
 * @generated SignedSource<<4a0d8813dc82e4904f6b5f9ef528fc23>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteInvoiceInput = {
  id: string;
};
export type DeleteInvoiceDialogMutation$variables = {
  input: DeleteInvoiceInput;
};
export type DeleteInvoiceDialogMutation$data = {
  readonly deleteInvoice: {
    readonly id: string;
  };
};
export type DeleteInvoiceDialogMutation = {
  response: DeleteInvoiceDialogMutation$data;
  variables: DeleteInvoiceDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteInvoiceDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IdPayload",
        "kind": "LinkedField",
        "name": "deleteInvoice",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteInvoiceDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IdPayload",
        "kind": "LinkedField",
        "name": "deleteInvoice",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e6286275fae33e40074315521893d982",
    "id": null,
    "metadata": {},
    "name": "DeleteInvoiceDialogMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteInvoiceDialogMutation(\n  $input: DeleteInvoiceInput!\n) {\n  deleteInvoice(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "eff0cbf59a7daee25ff5c8a1f679b2af";

export default node;
